import { Nullable } from '@ps/utils';

/**
 * Format date as `YYYYMMDD`, no separators, built from
 * local date parts (e.g. `20260804` for 2026-08-04).
 */
export function formatDate(date: Nullable<Date> | undefined): string {
  if (!date) return '';

  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');

  return `${year}${month}${day}`;
}
